import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ellipsis',
})
export class EllipsisPipe implements PipeTransform {
  private numberOfChar = 21;
  transform(value: string, numberOfChar?: number): string {
    numberOfChar && (this.numberOfChar = numberOfChar);
    if (value.length <= this.numberOfChar) {
      return value;
    }
    const newValue = value.substring(0, this.numberOfChar - 1);
    return `${newValue}...`;
  }
}
